import { Dispatch, MiddlewareAPI, Middleware } from "redux";
import errorHandler from "./errorHandler";

/**
 * Middleware that wraps redux actions to make sure errors are logged for any redux thrown exceptions.
 *
 * @param {Store} store
 */
const reduxErrorMiddleware: Middleware = (_store: MiddlewareAPI): any => (
  next: Dispatch
) => (action: any) => {
  try {
    return next(action);
  } catch (error) {
    console.error("Error thrown in redux", error);
    errorHandler(error as Error);
    throw error;
  }
};

export default reduxErrorMiddleware;
